import { Outlet } from "react-router-dom";
import { LocaleContext } from "../contexts/LocaleContext";
import { useContext } from "react";

const AuthLayout = () => {
  const { lang, changeLanguage } = useContext(LocaleContext);
  return (
    <>
      <div className="auth-layout">
        <div className="section-language">
          <select
            className="form-control"
            value={lang}
            onChange={(e) => changeLanguage(e.target.value)}
          >
            <option value="en">English</option>
            <option value="ar">Arabic</option>
          </select>
        </div>
        <Outlet />
      </div>
    </>
  );
};

export default AuthLayout;
